import { render } from "./CustomizeEventBrowse.vue?vue&type=template&id=4715a873"
import script from "./CustomizeEventBrowse.vue?vue&type=script&lang=js"
export * from "./CustomizeEventBrowse.vue?vue&type=script&lang=js"

import "./CustomizeEventBrowse.vue?vue&type=style&index=0&id=4715a873&lang=scss&scope=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__